<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Séquence Pilotage</h2>
    </div>
  </div>
  <div class="row">
    <div class="col"/>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="sequencesAfter"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          dataKey="texte"
          :paginator="true"
          :rows="10"
          sort-field="texte"
          :sortOrder="1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} séquences"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="texte"
            header="Nom"
            :sortable="true"
        ></Column>
        <Column field="valeur" header="Valeur" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText type="number" v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <div class="row">
              <div class="col">
                <Button
                    icon="pi pi-save"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="sauvegarder(slotProps.data)"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Séquence Pilotage");
    
    this.$store.dispatch('pilotage/obtenirSequencesAction')
    .then((res) => {
      this.sequencesBefore = res.data;
      this.sequencesAfter = JSON.parse(JSON.stringify(this.sequencesBefore));
    });
  },
  data() {
    return {
      sequencesBefore: [],
      sequencesAfter: []
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    sauvegarder(data) {
      this.sequencesBefore.forEach((current) => {
        if((String(current.texte) === String(data.texte))){
          if((Number(current.valeur) >= Number(data.valeur))){
          this.$toast.add({
            severity:'error',
            summary: 'Modifier Séquence',
            detail:"La nouvelle valeur doit être plus élevée",
            life: 6000
          });
          }else {
            let sequence = {};
            sequence.texte = data.texte;
            sequence.valeur = data.valeur;
            this.$store.dispatch('pilotage/modifierSequenceAction', {sequence: sequence})
            .then(() => {
              current.valeur = data.valeur;
              this.$toast.add({
                severity:'success',
                summary: 'Modifier Séquence',
                detail:"La séquence a été modifiée",
                life: 6000
              });
            });
          }
        }
      })

    }
  }
}
</script>
